<template>
    <v-card>
        <v-card-title>
        <span class="headline">Welcome to Tasko!</span>
        </v-card-title>
        <v-card-text>
            Manage your tasks and notices easily!
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="$store.commit('CLOSE_POPUP')" text>OK</v-btn>
        </v-card-actions>       
    </v-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'Add',
        data: function () {
            return {
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>